import {
  Certificate,
  CertificateCreateRequest,
  CertificateDictionaryModel,
  CertificateUpdateRequest,
  ConsolidateCertificatesRequest,
} from "../models/certificate.model";
import { BackendHttpService } from "./backendHttpService";
import { certificateDictionaryService } from "./dictionaries";

export class CertificateService extends BackendHttpService {
  constructor() {
    super("dictionary/certificates");
  }

  // Dictionary methods - delegated to dictionary service
  async getCertificatesDictionary(): Promise<CertificateDictionaryModel[]> {
    return certificateDictionaryService.getCertificatesDictionary();
  }

  // Clear cache when dictionary changes - delegates to dictionary service
  private clearCache(): void {
    certificateDictionaryService.clearCache();
  }

  // CRUD operations
  async createCertificate(
    request: CertificateCreateRequest
  ): Promise<Certificate> {
    try {
      const certificate = await this.post<
        CertificateCreateRequest,
        Certificate
      >(request, "");
      this.clearCache();
      return certificate;
    } catch (error) {
      console.error("Error creating certificate:", error);
      throw error;
    }
  }

  async updateCertificate(
    certificateId: number,
    request: CertificateUpdateRequest
  ): Promise<Certificate> {
    try {
      const certificate = await this.put<CertificateUpdateRequest, Certificate>(
        request,
        `/${certificateId}`
      );
      this.clearCache();
      return certificate;
    } catch (error) {
      console.error("Error updating certificate:", error);
      throw error;
    }
  }

  async deleteCertificate(certificateId: number): Promise<void> {
    try {
      await this.delete(`/${certificateId}`);
      this.clearCache();
    } catch (error) {
      console.error("Error deleting certificate:", error);
      throw error;
    }
  }

  async consolidateCertificates(
    request: ConsolidateCertificatesRequest
  ): Promise<Certificate> {
    try {
      const certificate = await this.post<
        ConsolidateCertificatesRequest,
        Certificate
      >(request, "/consolidate");
      this.clearCache();
      return certificate;
    } catch (error) {
      console.error("Error consolidating certificates:", error);
      throw error;
    }
  }

  // Helper method to get certificate by ID from cache or API
  async getCertificateById(id: number): Promise<Certificate | undefined> {
    try {
      const certificates = await this.getCertificatesDictionary();
      return certificates.find((cert) => cert.id === id);
    } catch (error) {
      console.error("Error getting certificate by ID:", error);
      throw error;
    }
  }
}
